'use client';

import { useEffect, useRef, useState } from "react";
import classes from "./public_provider_description.module.css";
import CustomButton from "../common/buttons/button";
import { sanitizeHTML } from '@/utils/sanitizeHTML';

export default function PublicProviderDescription({provider}) {
    const [showAll, setShowAll] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const sanitizedDescription = sanitizeHTML(provider.description || '');

    const outerRef = useRef();
    const innerRef = useRef();

    useEffect(() => {
        if(outerRef && innerRef && outerRef.current && innerRef.current) {
            setShowButton(outerRef.current.offsetHeight < innerRef.current.offsetHeight)
        }
    }, [outerRef?.current?.offsetHeight, innerRef?.current?.offsetHeight, showAll, sanitizedDescription])

    const handleClick = () => {
        setShowAll(!showAll);
    }

    return <div className={`${classes["public-provider-description-main-container"]}`}>
        <div className="d-flex flex-column align-self-stretch gap-4">
            <h3 className={`margin-0 color-gray-800 display-sm-semibold ${classes["public-provider-description-main-title"]}`}>{provider.name}</h3>
            <div className={`${classes["public-provider-description-divider"]}`} />
        </div>
        <div ref={outerRef} className={`${classes["public-provider-description-outer"]} ${showAll ? classes["show-all"] : ""}`}>
            {sanitizedDescription && <div ref={innerRef} className={`${classes["public-provider-description-inner"]} text-lg-regular`} dangerouslySetInnerHTML={{__html: sanitizedDescription}} />}
        </div>
        {((showButton && !showAll) || showAll) && <div className="d-flex flex-column align-self-stretch align-items-center">
            <CustomButton size="md" hierarchy="primary" onClick={handleClick} >{showAll ? "Teljesn szöveg elrejtése" : "Teljes szöveg megjelenítése"}</CustomButton>
        </div>}
    </div>
}